<template>
  <b-container fluid class="gradient">
    <b-row align-h="center" class="full-height">
      <b-col md="6" lg="4" align-self="center">
        <b-card>
          <div class="text-center">
            <img class="logo" src="/img/new-logo.svg" />
          </div>
          <h2 class="text-sm-center">Page not found</h2>
          <p class="card-text text-sm-center">
            The page you requested does not exist.
            <b-button variant="primary" @click="goBack" class="mt-4">Go back</b-button>
          </p>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script type="text/javascript">
export default {
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    }
  }
}
</script>
